// extracted by mini-css-extract-plugin
export default {"audio_tag":"e2ec9c"};